import { CookieName } from './enums'

export const COOKIE_NAMES: Record<string, CookieName> = {
  performance: CookieName.Performance,
  advertising: CookieName.Advertising,
}
